module.exports = __webpack_public_path__ + "media/images/net_profit_example-243d2476d8b3445b7827375db7d4c53e.png";